export default function toggleInArray(arr, el) {
  if (arr.includes(el)) {
    return arr.filter(arrayEl => arrayEl !== el);
  }
  return [...arr, el];
}
